export default "__VITE_ASSET__B5JuWj1$__"